import { DateStringValue } from '@mantine/dates';
import dayjs from 'dayjs';

export const handleMonthChange = (
  date: DateStringValue,
  setDate: (date: DateStringValue) => void,
  month: number
): void => {
  setDate(dayjs(date).month(month).startOf('month').format('YYYY-MM-DD'));
};
